import React from 'react';
import { Code, PenTool, BarChart, MapPin, Link as LinkIcon, Search, Globe } from 'lucide-react';
import { Button } from './ui/button';

const iconMap = {
  globe: Globe,
  code: Code,
  'pen-tool': PenTool,
  'bar-chart': BarChart,
  'map-pin': MapPin,
  link: LinkIcon,
  search: Search
};

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="bg-gray-50 dark:bg-gray-900 py-10">
      <div className="container mx-auto px-4">
        <p className="text-center text-gray-500 dark:text-gray-400 text-sm mb-6">
          Tap a focus area to filter the calendar.
        </p>
        <div className="flex flex-wrap justify-center gap-2">
          {categories.map((category) => {
            const Icon = iconMap[category.icon];
            const isSelected = selectedCategory === category.id;
            return (
              <Button
                key={category.id}
                onClick={() => onSelectCategory(category.id)}
                variant="outline"
                className={`
                  flex items-center gap-2 px-5 py-2.5 rounded-full border-2 transition-all font-medium text-sm
                  ${isSelected
                    ? 'bg-purple-600 text-white border-purple-600 hover:bg-purple-700 hover:border-purple-700'
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-purple-400 hover:text-purple-600 dark:hover:border-purple-500'
                  }
                `}
              >
                {Icon && <Icon className="w-4 h-4" />}
                {category.name}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
